import templateData from './templates.json';
import type { PromptTemplate } from './types';

export const promptTemplates = templateData as PromptTemplate[];

const libraryOrder = [
  'bright-orange-platform',
  'pastel-tropical-juice',
  'summer-beach-juice',
  'premium-fruit-beverage-hero',
  'milk-drink-spiral',
  'tropical-coconut-juice',
  'frozen-coconut-strawberry',
  'frozen-fruit-macro',
];
const libraryRanks = new Map(libraryOrder.map((id, index) => [id, index]));
/** Curated library order; keep unlisted templates in their original relative order. */
export const promptLibraryTemplates = [...promptTemplates].sort((a, b) =>
  (libraryRanks.get(a.id) ?? libraryOrder.length) - (libraryRanks.get(b.id) ?? libraryOrder.length));

/** Reserve twelve homepage positions; unpublished artwork stays non-interactive. */
export const promptShortcutSlots = Array.from({ length: 12 }, (_, index) => promptTemplates[index] ?? null);

export function getPromptTemplate(templateId: string) {
  return promptTemplates.find(template => template.id === templateId);
}

/** Small artwork for the homepage buttons; the editor retains the full poster. */
export function promptShortcutThumbnail(templateId: string) {
  return `assets/prompts/shortcuts/${templateId}.webp`;
}
